import { render, staticRenderFns } from "./sexChip.vue?vue&type=template&id=63ec6e28"
import script from "./sexChip.vue?vue&type=script&lang=js"
export * from "./sexChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports